export const selectGlobalPastState = (state) => state.undoRedoState.global?.past;

export const selectLatestGlobalPastState = (state) => {
  const allPastState = selectGlobalPastState(state);

  return allPastState[allPastState.length - 1];
};

export const selectGlobalPresentState = (state) => state.undoRedoState.global?.present;

export const selectGlobalPresentId = (state) => state.undoRedoState.global?.present?.id;
